import React, { useState } from 'react';
import { toast } from 'react-hot-toast';
import api from '../../common/api';
import Modal from '../../common/modal';
import { changeModal } from '../../common/utils';

const Withdraw = ({ userInfo }) => {
    const [withdrawType, setWithdrawType] = useState('');
    const [account, setAccount] = useState('');

    const handleWithdraw = async () => {
        if (!withdrawType || !account) {
            toast.error('请填写完整信息');
            return;
        }

        // 检查余额是否达到100元
        if (userInfo.aff < 100) {
            toast.error('奖励不足100元，无法提现');
            return;
        }

        try {
            const response = await api("post", "/api/user/txapply", {
                cage: withdrawType,
                account: account
            });

            if (response.message === "401") {
                localStorage.clear();
                window.location.href = '/login';
            } else {
                if (response.status) {
                    toast.success("提现申请已提交");
                    changeModal('withdraw', false);
                } else {
                    toast.error(response.message);
                }
            }
        } catch (error) {
            toast.error("网络错误，请重试");
        }
    };

    return (
        <>
            <button
                onClick={() => changeModal('withdraw', true)}
                className="w-full mt-4 flex items-center justify-center space-x-2 bg-gradient-to-r from-green-500 to-emerald-600 text-white px-4 py-2 rounded-lg hover:from-green-600 hover:to-emerald-700 transition-all duration-300"
            >
                <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
                <span>申请提现</span>
            </button>

            <Modal target="withdraw" title="申请提现">
                <div className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">提现方式</label>
                        <select
                            value={withdrawType}
                            onChange={(e) => setWithdrawType(e.target.value)}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                        >
                            <option value="">请选择提现方式</option>
                            <option value="usdt_trc20">USDT (TRC20)</option>
                            <option value="usdt_pol">USDT (POL)</option>
                            <option value="alipay">支付宝</option>
                        </select>
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">收款账号</label>
                        <input
                            type="text"
                            value={account}
                            onChange={(e) => setAccount(e.target.value)}
                            placeholder="请输入收款账号"
                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                        />
                    </div>

                    <div className="bg-yellow-50 p-4 rounded-md">
                        <p className="text-sm text-yellow-700">
                            {withdrawType === 'alipay' ? '支付宝提现将收取5%手续费' : 'USDT提现无手续费'}
                        </p>
                    </div>

                    <button
                        onClick={handleWithdraw}
                        className="w-full flex items-center justify-center space-x-2 bg-gradient-to-r from-blue-500 to-indigo-600 text-white px-4 py-2 rounded-lg hover:from-blue-600 hover:to-indigo-700 transition-all duration-300"
                    >
                        <span>确认提现</span>
                    </button>
                </div>
            </Modal>
        </>
    );
};

export default Withdraw; 